import React, { FC, PropsWithChildren } from 'react';
import { styled } from 'linaria/react';
const FullViewportHeightSection: FC<PropsWithChildren<{
  faq?: boolean;
}>> = ({
  faq = false,
  children
}) => <FullViewportHeightSectionWrapper faq={faq}>{children}</FullViewportHeightSectionWrapper>;
export default FullViewportHeightSection;
const _exp = /*#__PURE__*/() => ({
  faq
}) => faq ? 'auto' : '100vh';
const FullViewportHeightSectionWrapper = /*#__PURE__*/styled('div')({
  name: "FullViewportHeightSectionWrapper",
  class: "fjqzim6",
  propsAsIs: false,
  vars: {
    "fjqzim6-0": [_exp()]
  }
});

require("./FullViewportHeightSection.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./FullViewportHeightSection.tsx");